import React, { useEffect, useState, useCallback } from 'react';
import { Helmet } from 'react-helmet';
import { UtilityFunctions } from '../../utils/UtilityFunctions';
import { useDispatch } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { bindActionCreators } from "redux";
import { actionCreators } from "../../store";
import { cookieService, userService } from '../../_services';
import { STRING_CONSTANTS } from '../../utils/constants/stringConstants';
import ValidationErrorToast from '../../components/validationErrorToast';
import SuccessToast from '../../components/successToast';

// --- Constants ---
const AVAILABLE_VOICES = [
    { id: 'aGkVQvWUZi16EH8aZJvT', name: 'Steve (Default)', desc: '', default: true, url: 'https://storage.googleapis.com/eleven-public-prod/custom/voices/aGkVQvWUZi16EH8aZJvT/hUdpJvUH4knIjWwEeGyu.mp3'},
    { id: 'gZ25QC7GHcbM4iwAqulk', name: 'Tim', desc: '', url: 'https://storage.googleapis.com/eleven-public-prod/database/user/UqlmS3fqKkPB3Kxe6l43H9rmZBr1/voices/gZ25QC7GHcbM4iwAqulk/tjbX787FFYkEx6ZBk7Jy.mp3'},
    { id: '319bKIhetA5g6tmywrwj', name: 'Gemma', desc: '', url: 'https://storage.googleapis.com/eleven-public-prod/B6XKo1XG4CdCYGvSECuh2iFjzTq1/voices/319bKIhetA5g6tmywrwj/f40d37fb-ac3b-4914-aaf8-f79ff1e40563.mp3'},
    { id: 'JGIWhSd306fVRtZfD1OA', name: 'Alex', desc: '', url: 'https://storage.googleapis.com/eleven-public-prod/q8zuFD4ZjXYZNb8cWTy9Ou0CtaL2/voices/JGIWhSd306fVRtZfD1OA/22ec892b-347f-48dc-9acd-a6d846f31f89.mp3'},
    { id: 'd9rRtAT3qedrNbvmbykg', name: 'Will', desc: '', url: 'https://storage.googleapis.com/eleven-public-prod/custom/voices/d9rRtAT3qedrNbvmbykg/jvwceYyY7TMLBHNNRuFF.mp3'},
    { id: 'MiueK1FXuZTCItgbQwPu', name: 'Maya', desc: '', url: 'https://storage.googleapis.com/eleven-public-prod/custom/voices/MiueK1FXuZTCItgbQwPu/dY0JGbhvAH2WTEuoj9Bu.mp3'},
    { id: 'M7ya1YbaeFaPXljg9BpK', name: 'Hannah Jayne', desc: '', url: 'https://storage.googleapis.com/eleven-public-prod/database/user/7tvaSRybYYZ7ja2RTmrVkfJ75f93/voices/M7vaSRybYYZ7ja2RTmrVkfJ75f93/voices/M7ya1YbaeFaPXljg9BpK/8Wc09F9557roFsMSjG9E.mp3'},
    { id: '2nzji8yPQooBwG4eQO4s', name: 'John C', desc: '', url: 'https://storage.googleapis.com/eleven-public-prod/database/user/65SEE4Sx3cgZtuy8loIdatKOCAP2/voices/2nzji8yPQooBwG4eQO4s/IIzySX64Ezkj4ylWqrl5.mp3'},
    { id: 'NihRgaLj2HWAjvZ5XNxl', name: 'Matilda', desc: '', url: 'https://storage.googleapis.com/eleven-public-prod/custom/voices/NihRgaLj2HWAjvZ5XNxl/OrIdbMk7IHZvEOEVlsQ0.mp3'},
    { id: 'sai9UY7iXkRDSsXHR0bZ', name: 'Ben', desc: '', url: 'https://storage.googleapis.com/eleven-public-prod/database/user/IbGEr7k62hYnUndiEtdtV54pnbs1/voices/sai9UY7iXkRDSsXHR0bZ/5NrxCi9pzZbyENe8FAo9.mp3'},
    { id: 'HDA9tsk27wYi3uq0fPcK', name: 'Stuart', desc: '', url: 'https://storage.googleapis.com/eleven-public-prod/database/user/3LUrnzimItRhFJyBGCNQfSc602Y2/voices/HDA9tsk27wYi3uq0fPcK/4AhIQcGzr8aDvnONN3bh.mp3'},
    { id: 'p43fx6U8afP2xoq1Ai9f', name: 'Emily', desc: '', url: 'https://storage.googleapis.com/eleven-public-prod/custom/voices/p43fx6U8afP2xoq1Ai9f/zs7hPpzFI1bDorvMkY1S.mp3'},
    { id: 'mWNaiDAPDAx080ro4nL5', name: 'Baz', desc: '', url: 'https://storage.googleapis.com/eleven-public-prod/database/user/4jd2taMCJEbpEc9UOOIkqbnr25f2/voices/mWNaiDAPDAx080ro4nL5/KpqGhJNeegsctFx6I88k.mp3'},
    { id: 'v7AjIzCg6vdhCmXwBrb1', name: 'Ian', desc: '', url: 'https://storage.googleapis.com/eleven-public-prod/database/user/ewdfKQmq34ecRnjie0F9o1SFEFs2/voices/v7AjIzCg6vdhCmXwBrb1/bXYrWiWIErO8NxtmqRi4.mp3'},
    { id: 'sx8pHRzXdQfuUYPGFK7X', name: 'Anna', desc: '', url: 'https://storage.googleapis.com/eleven-public-prod/database/user/Ib8YRLFGZcfUWFZbcvIMMjy0fv93/voices/sx8pHRzXdQfuUYPGFK7X/yp6G4CygiVVHU2jFJHLK.mp3'},
    { id: 'nBoLwpO4PAjQaQwVKPI1', name: 'Amelia', desc: '', url: 'https://storage.googleapis.com/eleven-public-prod/database/user/zMfVYhWBQcWhDcafePbjm8CD5Lx2/voices/nBoLwpO4PAjQaQwVKPI1/pEX4zUYPQmsyqSF5AcW4.mp3'},
];
const DEFAULT_VOICE_ID = AVAILABLE_VOICES.find(v => v.default)?.id || AVAILABLE_VOICES[0]?.id || '';

const PERSONALITY_TYPES = [
    { id: 'professional', name: 'Professional', description: 'Formal and business-like' },
    { id: 'friendly', name: 'Friendly', description: 'Warm and approachable' },
    { id: 'empathetic', name: 'Empathetic', description: 'Understanding and compassionate' },
    { id: 'assertive', name: 'Assertive', description: 'Direct and confident' },
    { id: 'diplomatic', name: 'Diplomatic', description: 'Tactful and considerate' },
];
const DEFAULT_PERSONALITY_ID = PERSONALITY_TYPES[0]?.id || '';

const DAYS_OF_WEEK = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
const PRE_DUE_DATE_REMINDER_OPTIONS = [1, 2, 3, 5, 7]; // Days

// --- Interfaces ---
interface Shift {
    enabled: boolean;
    startTime: string;
    endTime: string;
    voiceId: string;
    personalityId: string;
}

interface DaySchedule {
    day: string;
    shifts: [Shift, Shift];
}

interface PersonalityOverride {
    enabled: boolean;
    daysPastPaymentTerms: number;
    personalityId: string;
}

interface ARSettingsRouteParams {
    organizationId: string;
}

interface ARSettingsProps extends RouteComponentProps<ARSettingsRouteParams> {}

// --- Styles (Adjusted for Compactness and Scrolling) ---
const styles: { [key: string]: React.CSSProperties } = {
    container: { backgroundColor: '#1a1a2e', minHeight: '100vh', display: 'flex', flexDirection: 'column' }, // Make container flex column
    topBar: {
        background: 'rgba(255, 255, 255, 0.05)', padding: '12px 20px', display: 'flex',
        justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px',
    },
    topBarTitle: { color: '#ffffff', margin: 0, fontSize: '22px', fontWeight: '500' },
    backButton: {
        padding: '8px 16px', borderRadius: '6px', border: 'none', cursor: 'pointer', display: 'inline-flex',
        alignItems: 'center', gap: '6px', fontSize: '13px', fontWeight: '500',
        backgroundColor: 'rgba(255, 255, 255, 0.15)', color: '#ffffff', transition: 'background-color 0.2s ease',
    },
    blueBox: {
        background: 'rgba(30, 30, 50, 0.75)', borderRadius: '10px', padding: '20px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.2)', marginBottom: '20px',
    },
    sectionTitle: {
        color: '#f0f0f0', fontSize: '18px', fontWeight: '600', marginBottom: '16px',
        display: 'flex', alignItems: 'center', gap: '10px',
        borderBottom: '1px solid rgba(255, 255, 255, 0.1)', paddingBottom: '10px',
    },
    whiteText: { color: '#f0f0f0' },
    mutedText: { color: 'rgba(224, 224, 224, 0.65)', fontSize: '12px' },
    label: {
        color: 'rgba(224, 224, 224, 0.8)', marginBottom: '6px', display: 'block',
        fontSize: '13px', fontWeight: '500',
    },
    input: {
        width: '100%', padding: '8px 12px', fontSize: '13px', color: '#ffffff',
        backgroundColor: 'rgba(255, 255, 255, 0.08)', border: '1px solid rgba(255, 255, 255, 0.15)',
        borderRadius: '5px', outline: 'none', marginBottom: '12px',
    },
    textarea: { minHeight: '80px', resize: 'vertical' },
    select: {
        width: '100%', padding: '8px 12px', fontSize: '13px', color: '#ffffff',
        backgroundColor: 'rgba(255, 255, 255, 0.08)', border: '1px solid rgba(255, 255, 255, 0.15)',
        borderRadius: '5px', outline: 'none', cursor: 'pointer', marginBottom: '12px',
    },
    selectOption: { backgroundColor: '#1a1a2e', color: '#f0f0f0' },
    switchContainer: { display: 'flex', alignItems: 'center', marginBottom: '12px', justifyContent: 'space-between' },
    switchLabelText: { color: 'rgba(224, 224, 224, 0.8)', fontSize: '13px', marginRight: '10px' },
    switch: { position: 'relative', display: 'inline-block', width: '44px', height: '24px' },
    switchInput: { opacity: 0, width: 0, height: 0 },
    switchSlider: {
        position: 'absolute', cursor: 'pointer', top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.2)', borderRadius: '24px', transition: '0.4s',
    },
    switchSliderChecked: { backgroundColor: '#007bff' },
    switchKnob: {
        position: 'absolute', content: '""', height: '18px', width: '18px',
        left: '3px', bottom: '3px', backgroundColor: 'white', borderRadius: '50%', transition: '0.4s',
    },
    switchKnobChecked: { transform: 'translateX(20px)' },
    button: {
        padding: '8px 16px', borderRadius: '5px', border: 'none', cursor: 'pointer',
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '6px',
        fontSize: '13px', fontWeight: '500',
        transition: 'background-color 0.2s ease, opacity 0.2s ease, transform 0.1s ease',
        lineHeight: '1.2',
    },
    primaryButton: { backgroundColor: '#007bff', color: '#ffffff' },
    previewButton: {
        backgroundColor: 'rgba(255, 255, 255, 0.1)', color: '#f0f0f0',
        border: '1px solid rgba(255, 255, 255, 0.2)', padding: '6px 10px', marginLeft: '8px',
    },
    timetableDayRow: {
        display: 'flex', alignItems: 'flex-start', padding: '12px 0',
        borderBottom: '1px solid rgba(255, 255, 255, 0.08)', gap: '12px',
    },
    timetableDayLabel: {
        color: '#f0f0f0', fontWeight: '600', fontSize: '14px', width: '100px',
        flexShrink: 0, paddingTop: '8px',
    },
    timetableShiftsWrapper: { display: 'flex', flexDirection: 'column', gap: '12px', flexGrow: 1 },
    timetableShiftContainer: { padding: '12px', background: 'rgba(0,0,0,0.15)', borderRadius: '6px' },
    timetableShiftHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' },
    timetableShiftControls: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(130px, 1fr))', gap: '10px' },
    timeInput: {
        padding: '6px 8px', fontSize: '13px', color: '#ffffff',
        backgroundColor: 'rgba(255, 255, 255, 0.08)',
        border: '1px solid rgba(255, 255, 255, 0.15)', borderRadius: '5px', width: '100%'
    },
    validationErrorBox: {
        background: 'rgba(220, 53, 69, 0.1)', border: '1px solid rgba(220, 53, 69, 0.5)',
        borderRadius: '8px', padding: '12px 16px', marginBottom: '20px', color: '#f8d7da',
    },
    validationErrorList: { margin: 0, paddingLeft: '18px', fontSize: '13px' },
    loadingOverlay: {
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0, 0, 0, 0.7)',
        display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 10000,
    },
    saveButtonContainer: {
        display: 'flex', justifyContent: 'flex-end', marginTop: '24px',
        paddingTop: '16px', borderTop: '1px solid rgba(255, 255, 255, 0.1)',
    },
    infoText: { fontSize: '13px', color: 'rgba(224, 224, 224, 0.8)', marginBottom: '12px', lineHeight: 1.5 },
    formRow: { display: 'flex', gap: '20px', flexWrap: 'wrap' },
    formCol: { flex: '1 1 calc(50% - 10px)', minWidth: '300px' },
    overrideTier: { border: '1px solid rgba(255,255,255,0.1)', padding: '12px', borderRadius: '6px', marginBottom: '12px'},
};

// --- ToggleSwitch Component ---
const ToggleSwitch = ({ isOn, handleToggle, disabled = false, label }) => {
    return (
        <div style={styles.switchContainer} onClick={(e) => { if (disabled) e.preventDefault(); else handleToggle(); }}>
            <span style={styles.switchLabelText}>{label}</span>
            <div style={{ ...styles.switch, cursor: disabled ? 'not-allowed' : 'pointer' }}>
                <input type="checkbox" checked={isOn} disabled={disabled} onChange={() => {}} style={styles.switchInput} />
                <span style={{ ...styles.switchSlider, ...(isOn ? styles.switchSliderChecked : {}), ...(disabled ? { opacity: 0.5 } : {}) }}>
                    <span style={{ ...styles.switchKnob, ...(isOn ? styles.switchKnobChecked : {}) }} />
                </span>
            </div>
        </div>
    );
};

// --- Main Component ---
const WhitelabelSettings = (props: ARSettingsProps) => {
    const { organizationId } = props.match.params;
    const dispatch = useDispatch();
    const { setUnreadNotificationCount } = bindActionCreators(actionCreators, dispatch);
    
    const userCookie = cookieService?.getCookie(STRING_CONSTANTS?.cookieStrings?.user);
    const isUserLoggedIn = cookieService.getCookie(STRING_CONSTANTS.cookieStrings.token);

    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const [validationErrors, setValidationErrors] = useState<string[]>([]);
    const [isPlayingPreview, setIsPlayingPreview] = useState(false);
    const audioRef = React.useRef<HTMLAudioElement | null>(null);

    // Settings States
    const [collectionsEnabled, setCollectionsEnabled] = useState(true);
    const [selectedVoice, setSelectedVoice] = useState(DEFAULT_VOICE_ID);
    const [personality, setPersonality] = useState(DEFAULT_PERSONALITY_ID);
    
    const [outboundKnownCustomerGreeting, setOutboundKnownCustomerGreeting] = useState(
        "Hello {customer_name}, this is {agent_name} from {organization_name} regarding your outstanding invoice."
    );
    const [outboundUnknownCustomerGreeting, setOutboundUnknownCustomerGreeting] = useState(
        "Hello, this is {agent_name} from {organization_name}. Am I speaking with someone from your accounts department?"
    );

    // New incoming call greetings
    const [incomingKnownCustomerGreeting, setIncomingKnownCustomerGreeting] = useState(
        "Thanks for calling {organization_name}, {customer_name}. How can I help you today?"
    );
    const [incomingUnknownCustomerMessage, setIncomingUnknownCustomerMessage] = useState(
        "Thanks for calling {organization_name}. We specialize in [Your Services Here]. How can I direct your call?"
    );

    const [initialCallDaysPastPaymentTerms, setInitialCallDaysPastPaymentTerms] = useState(7);
    const [enablePreDueDateReminders, setEnablePreDueDateReminders] = useState(false);
    const [reminderDaysBeforeDueDate, setReminderDaysBeforeDueDate] = useState(3);
    const [personalityOverrides, setPersonalityOverrides] = useState<PersonalityOverride[]>([
        { enabled: false, daysPastPaymentTerms: 30, personalityId: DEFAULT_PERSONALITY_ID },
        { enabled: false, daysPastPaymentTerms: 60, personalityId: DEFAULT_PERSONALITY_ID },
        { enabled: false, daysPastPaymentTerms: 90, personalityId: DEFAULT_PERSONALITY_ID },
    ]);
    const [followUpFrequency, setFollowUpFrequency] = useState('weekly');
    const [maxAttempts, setMaxAttempts] = useState(5);

    const [storeCallRecordings, setStoreCallRecordings] = useState(true);
    const [recordingAnnouncement, setRecordingAnnouncement] = useState(
        "This call may be recorded for quality assurance and training purposes. By continuing, you consent to this."
    );

    const [limitCallsByAmountEnabled, setLimitCallsByAmountEnabled] = useState(false);
    const [limitCallsComparisonType, setLimitCallsComparisonType] = useState('greater_than'); // 'greater_than' or 'less_than'
    const [limitCallsAmount, setLimitCallsAmount] = useState(100);

    const initialShiftState: Shift = {
        enabled: false, startTime: '09:00', endTime: '17:00',
        voiceId: DEFAULT_VOICE_ID, personalityId: DEFAULT_PERSONALITY_ID,
    };
    const initialTimetable: DaySchedule[] = DAYS_OF_WEEK.map(day => ({
        day,
        shifts: [
            { ...initialShiftState, enabled: day !== 'Saturday' && day !== 'Sunday' },
            { ...initialShiftState, startTime: '13:00', endTime: '17:00' } 
        ]
    }));
    const [timetable, setTimetable] = useState<DaySchedule[]>(initialTimetable);

    // --- Effects ---
    useEffect(() => {
        if (!isUserLoggedIn) {
            props.history.push(STRING_CONSTANTS.navigationString.login);
            return; // Early exit if not logged in
        }

        loadSettings();

        if (userCookie?.user?.unreadNotificationCount !== undefined) {
             setUnreadNotificationCount(userCookie.user.unreadNotificationCount);
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [organizationId, isUserLoggedIn, props.history]);





// --- Then, replace your existing loadSettings function with this one ---

    const loadSettings = async () => {
        setIsLoading(true);
        try {
            const response = await userService.aiRequest({
                method: 'get-ar-settings', data: { organizationId },
            }, true);

            if (response.data?.settings) {
                let st = response.data.settings;

                setLimitCallsByAmountEnabled(st.limitCallsByAmountEnabled ?? false);
                setLimitCallsComparisonType(st.limitCallsComparisonType || 'greater_than');
                setLimitCallsAmount(st.limitCallsAmount ?? 100);

                setCollectionsEnabled(st.collectionsEnabled ?? true); // Changed from st.collections_enabled
                setSelectedVoice(st.aiVoice || DEFAULT_VOICE_ID); // Changed from st.ai_voice
                setPersonality(st.aiPersonality || DEFAULT_PERSONALITY_ID); // Changed from st.ai_personality
                setOutboundKnownCustomerGreeting(st.knownCustomerGreeting || outboundKnownCustomerGreeting); // Changed from st.known_customer_greeting
                setOutboundUnknownCustomerGreeting(st.unknownCustomerGreeting || outboundUnknownCustomerGreeting); // Changed from st.unknown_customer_greeting
                
                // New settings to load (all now using camelCase)
                setIncomingKnownCustomerGreeting(st.incomingKnownCustomerGreeting || incomingKnownCustomerGreeting); // Changed
                setIncomingUnknownCustomerMessage(st.incomingUnknownCustomerMessage || incomingUnknownCustomerMessage); // Changed
                setInitialCallDaysPastPaymentTerms(st.initialCallDaysPastPaymentTerms ?? 7); // Changed
                setEnablePreDueDateReminders(st.enablePreDueDateReminders ?? false); // Changed
                setReminderDaysBeforeDueDate(st.reminderDaysBeforeDueDate ?? 3); // Changed
                
                const defaultOverridesConfig = [
                    { daysPastPaymentTerms: 30, personalityId: DEFAULT_PERSONALITY_ID },
                    { daysPastPaymentTerms: 60, personalityId: DEFAULT_PERSONALITY_ID },
                    { daysPastPaymentTerms: 90, personalityId: DEFAULT_PERSONALITY_ID },
                ];

                if (st.personalityOverrides && Array.isArray(st.personalityOverrides)) { // Changed from st.personality_overrides
                    const loadedOverrides = defaultOverridesConfig.map((defaultConfig) => {
                        // The keys within personalityOverrides are also converted by convertSnakeToCamel
                        const savedOverride = st.personalityOverrides.find(o => o.daysPastPaymentTerms === defaultConfig.daysPastPaymentTerms);
                        if (savedOverride) {
                            return {
                                enabled: savedOverride.enabled ?? false,
                                daysPastPaymentTerms: savedOverride.daysPastPaymentTerms,
                                personalityId: savedOverride.personalityId || defaultConfig.personalityId,
                            };
                        }
                        return { enabled: false, ...defaultConfig };
                    });
                    setPersonalityOverrides(loadedOverrides.slice(0, 3));
                } else {
                     setPersonalityOverrides(defaultOverridesConfig.map(conf => ({enabled: false, ...conf})));
                }

                setFollowUpFrequency(st.followUpFrequency || 'weekly'); // Changed
                setMaxAttempts(st.maxAttempts ?? 5); // Changed
                
                setStoreCallRecordings(st.storeCallRecordings ?? true); // Changed
                setRecordingAnnouncement(st.recordingAnnouncement || recordingAnnouncement); // Changed
                
                if (st.timetable && Array.isArray(st.timetable) && st.timetable.length === DAYS_OF_WEEK.length) { // Changed from st.timetable
                    // Basic validation for timetable structure
                    const isValidTimetable = st.timetable.every(daySchedule => 
                        daySchedule.day && DAYS_OF_WEEK.includes(daySchedule.day) &&
                        daySchedule.shifts && Array.isArray(daySchedule.shifts) && daySchedule.shifts.length === 2 &&
                        daySchedule.shifts.every(shift => 
                            typeof shift.enabled === 'boolean' &&
                            typeof shift.startTime === 'string' && // Keys within shifts are also camelCase now
                            typeof shift.endTime === 'string' &&
                            AVAILABLE_VOICES.some(v => v.id === shift.voiceId) &&
                            PERSONALITY_TYPES.some(p => p.id === shift.personalityId)
                        )
                    );
                    if (isValidTimetable) {
                        setTimetable(st.timetable);
                    } else {
                        console.warn("Loaded timetable is invalid, using default.");
                        setTimetable(initialTimetable); 
                    }
                } else {
                    setTimetable(initialTimetable); 
                }
            }
        } catch (error) {
            console.error("Failed to load settings:", error);
            ValidationErrorToast("Error", "Failed to load settings. Displaying default values.");
        } finally {
            setIsLoading(false);
        }
    };

    const validateSettings = (): string[] => {
        const errors: string[] = [];
        if (!outboundKnownCustomerGreeting.includes('{customer_name}') || !outboundKnownCustomerGreeting.includes('{organization_name}')) errors.push("Out. Known Greeting: Must include {customer_name} & {organization_name}.");
        if (!outboundUnknownCustomerGreeting.includes('{organization_name}')) errors.push("Out. Unknown Greeting: Must include {organization_name}.");
        if (!incomingKnownCustomerGreeting.includes('{customer_name}') || !incomingKnownCustomerGreeting.includes('{organization_name}')) errors.push("In. Known Greeting: Must include {customer_name} & {organization_name}.");
        if (!incomingUnknownCustomerMessage.includes('{organization_name}')) errors.push("In. Unknown Message: Must include {organization_name}.");
        
        if (initialCallDaysPastPaymentTerms < 0) errors.push("Days past payment terms for initial call must be 0 or more.");
        if (enablePreDueDateReminders && (reminderDaysBeforeDueDate < 1 || reminderDaysBeforeDueDate > 30)) errors.push("Reminder days before due date must be between 1 and 30.");
        if (maxAttempts < 1 || maxAttempts > 10) errors.push("Max call attempts must be 1-10.");

        if (limitCallsByAmountEnabled && (limitCallsAmount < 0 || limitCallsAmount === null)) {
            errors.push("Limit calls amount must be a positive number.");
        }
        let lastOverrideDays = -1;
        personalityOverrides.forEach((override, index) => {
            if (override.enabled) {
                if (override.daysPastPaymentTerms <= 0) errors.push(`Override ${index + 1}: Days past payment terms must be > 0.`);
                if (override.daysPastPaymentTerms <= lastOverrideDays && lastOverrideDays !== -1) errors.push(`Override ${index + 1}: Days must be greater than previous enabled override's days.`);
                if (!override.personalityId) errors.push(`Override ${index + 1}: Personality must be selected.`);
                lastOverrideDays = override.daysPastPaymentTerms;
            }
        });
        
        if (storeCallRecordings && !recordingAnnouncement.trim()) errors.push("Recording announcement cannot be empty if storing recordings.");

        timetable.forEach((day) => day.shifts.forEach((shift, si) => {
            if (shift.enabled) {
                // Basic time validation (e.g., '09:00' < '17:00')
                if (shift.startTime >= shift.endTime) {
                    errors.push(`${day.day} Shift ${si+1}: Start time must be before end time.`);
                }
                // Check if voiceId and personalityId are selected if shift is enabled
                if (!shift.voiceId) errors.push(`${day.day} Shift ${si+1}: Voice must be selected if enabled.`);
                if (!shift.personalityId) errors.push(`${day.day} Shift ${si+1}: Personality must be selected if enabled.`);
            }
        }));

        return errors;
    };

    const handleSaveSettings = async () => {
        const errors = validateSettings();
        setValidationErrors(errors);
        if (errors.length > 0) {
            errors.slice(0,3).forEach(error => ValidationErrorToast("Validation Error", error)); 
            return;
        }

        setIsSaving(true);
        try {
            await userService.aiRequest({
                method: 'save-ar-settings',
                data: {
                    organizationId,
                    settings: {
                        collections_enabled: collectionsEnabled,
                        ai_voice: selectedVoice,
                        ai_personality: personality,
                        known_customer_greeting: outboundKnownCustomerGreeting,
                        unknown_customer_greeting: outboundUnknownCustomerGreeting,
                        
                        // New settings to save
                        incoming_known_customer_greeting: incomingKnownCustomerGreeting,
                        incoming_unknown_customer_message: incomingUnknownCustomerMessage,
                        initial_call_days_past_payment_terms: initialCallDaysPastPaymentTerms,
                        enable_pre_due_date_reminders: enablePreDueDateReminders,
                        reminder_days_before_due_date: reminderDaysBeforeDueDate,
                        personality_overrides: personalityOverrides,
                        
                        follow_up_frequency: followUpFrequency,
                        max_attempts: maxAttempts,
                        store_call_recordings: storeCallRecordings,
                        recording_announcement: recordingAnnouncement,
                        timetable: timetable, // Send as is, backend will handle JSONB

                        limit_calls_by_amount_enabled: limitCallsByAmountEnabled,
                        limit_calls_comparison_type: limitCallsComparisonType,
                        limit_calls_amount: limitCallsAmount,
                    }
                },
            }, true);
            SuccessToast("Success", "Settings saved successfully!");
        } catch (error) {
            console.error("Failed to save settings:", error);
            ValidationErrorToast("Error", `Failed to save settings: ${error.message || 'Unknown error'}`);
        } finally {
            setIsSaving(false);
        }
    };
    
    const handleCollectionsToggleAndSave = async () => {
        const newCollectionsEnabledStatus = !collectionsEnabled;
        setCollectionsEnabled(newCollectionsEnabledStatus);
        setIsSaving(true); 

        try {
            const currentSettingsPayload = {
                collections_enabled: newCollectionsEnabledStatus,
                ai_voice: selectedVoice, ai_personality: personality,
                known_customer_greeting: outboundKnownCustomerGreeting, unknown_customer_greeting: outboundUnknownCustomerGreeting,
                
                // Ensure all settings are sent even on toggle
                incoming_known_customer_greeting: incomingKnownCustomerGreeting,
                incoming_unknown_customer_message: incomingUnknownCustomerMessage,
                initial_call_days_past_payment_terms: initialCallDaysPastPaymentTerms,
                enable_pre_due_date_reminders: enablePreDueDateReminders, reminder_days_before_due_date: reminderDaysBeforeDueDate,
                personality_overrides: personalityOverrides,
                
                follow_up_frequency: followUpFrequency, max_attempts: maxAttempts,
                store_call_recordings: storeCallRecordings, recording_announcement: recordingAnnouncement,
                timetable: timetable,

                limit_calls_by_amount_enabled: limitCallsByAmountEnabled,
                limit_calls_comparison_type: limitCallsComparisonType,
                limit_calls_amount: limitCallsAmount,
            };

            await userService.aiRequest({
                method: 'save-ar-settings',
                data: { organizationId, settings: currentSettingsPayload },
            }, true);
            SuccessToast("Success", `Collections ${newCollectionsEnabledStatus ? 'enabled' : 'disabled'}.`);
        } catch (error) {
            console.error("Failed to toggle collections:", error);
            ValidationErrorToast("Error", "Failed to update collections status.");
            setCollectionsEnabled(!newCollectionsEnabledStatus);
        } finally {
            setIsSaving(false);
        }
    };

    // --- Event Handlers ---
    const handleVoicePreview = async (voiceIdToPreview) => {
        if (isPlayingPreview && audioRef.current) {
            audioRef.current.pause(); audioRef.current.currentTime = 0; setIsPlayingPreview(false); return;
        }
        setIsPlayingPreview(true);
        try {
            const voiceData = AVAILABLE_VOICES.find(v => v.id === voiceIdToPreview);
            if (!voiceData?.url) throw new Error("Voice sample URL not found.");
            if (audioRef.current) audioRef.current.pause();
            audioRef.current = new Audio(voiceData.url);
            audioRef.current.onended = () => setIsPlayingPreview(false);
            audioRef.current.onerror = () => { setIsPlayingPreview(false); ValidationErrorToast("Error", "Failed to play voice preview."); };
            await audioRef.current.play();
        } catch (error) {
            console.error("Voice preview error:", error); ValidationErrorToast("Error", "Failed to play voice preview."); setIsPlayingPreview(false);
        }
    };

    const handleTimetableChange = (dayIndex: number, shiftIndex: number, field: keyof Shift, value: any) => {
        setTimetable(prev => prev.map((dayS, dIdx) => dIdx === dayIndex ? { ...dayS, shifts: dayS.shifts.map((sh, sIdx) => sIdx === shiftIndex ? { ...sh, [field]: value, ...(field === 'enabled' && value && !sh.voiceId && { voiceId: DEFAULT_VOICE_ID }), ...(field === 'enabled' && value && !sh.personalityId && { personalityId: DEFAULT_PERSONALITY_ID }) } : sh) as [Shift, Shift] } : dayS));
    };

    const handlePersonalityOverrideChange = (index: number, field: keyof PersonalityOverride, value: any) => {
        setPersonalityOverrides(prev => prev.map((override, i) => i === index ? { ...override, [field]: value, ...(field === 'enabled' && value && !override.personalityId && { personalityId: DEFAULT_PERSONALITY_ID }) } : override));
    };
    
    const handleLogout = (e) => {
        e.preventDefault();
        userService.logout()
            .then(() => {
                cookieService.removeAllCookies();
                props.history.push(STRING_CONSTANTS.navigationString.login);
            })
            .catch((err) => {
                console.error("Logout error:", err);
                cookieService.removeAllCookies();
                props.history.push(STRING_CONSTANTS.navigationString.login);
            });
    };

    // --- Render ---
    if (isLoading) {
        return <div style={styles.loadingOverlay}><div className="spinner-border" style={{ width: '3rem', height: '3rem', color: '#007bff' }} role="status"><span className="sr-only">Loading...</span></div></div>;
    }

    return (
        <section className="main-dashboard-wrap" style={styles.container}>
            <Helmet><title>MPLOI: AR Collection Settings</title></Helmet>
            <div id="wrapper" style={{ flexGrow: 1, display: 'flex' }}> {/* Adjusted for flex layout */}
                <ul className={`navbar-nav bg-gradient-primary sidebar sidebar-dark accordion`} id="accordionSidebar" style={{transition: 'none !important', overflowY: 'auto', flexShrink: 0, height: '100vh'}}> {/* Added overflowY and fixed height for sidebar scrolling */}
                    <div>
                        <Link style={{ pointerEvents: "none" }} className="sidebar-brand d-flex align-items-center justify-content-center" to="#"><img src={UtilityFunctions.getImageURL() + "db-logo.svg"} alt="Logo" /></Link>
                        {userCookie?.user?.isAccountsSignup === false && <li className="nav-item"><Link className="nav-link" to="/ar/affiliate/dashboard"><img src={UtilityFunctions.getImageURL() + "home-icon-blank-white.svg"} alt="Home" /><img src={UtilityFunctions.getImageURL() + "home-icon-fill-green.svg"} alt="Home Active" /></Link></li>}
                    </div>
                    <div style={{ marginTop: 'auto', paddingBottom: '20px' }}><li className='d-grid justify-content-center gap-2 text-white'><span style={{ cursor: "pointer" }} onClick={handleLogout}>Logout</span></li></div>
                </ul>

                <div id="content-wrapper" className="d-flex flex-column" style={{ flexGrow: 1, overflowY: 'auto' }}> {/* Made content-wrapper scrollable */}
                    <div id="content">
                        <div style={styles.topBar}>
                            <button style={styles.backButton} onClick={() => props.history.push('/ar')} disabled={isSaving}><span style={{ fontSize: '16px', lineHeight: '1' }}>←</span><span>Dashboard</span></button>
                            <h1 style={styles.topBarTitle}>Collection Settings</h1>
                            <button style={{ ...styles.button, ...styles.primaryButton, padding: '8px 16px', fontSize: '13px' }} onClick={handleSaveSettings} disabled={isSaving || isLoading}>
                                {isSaving ? 'Saving...' : 'Save Settings'}
                            </button>
                        </div>

                        <div className="container-fluid" style={{padding: '0 20px 20px 20px'}}>
                            {validationErrors.length > 0 && (
                                <div style={styles.validationErrorBox}>
                                    <h4 style={{ margin: '0 0 8px 0', fontSize: '15px' }}>Please correct the following errors:</h4>
                                    <ul style={styles.validationErrorList}>{validationErrors.map((e, i) => <li key={i}>{e}</li>)}</ul>
                                </div>
                            )}

                            <div style={{...styles.blueBox, paddingBottom: '10px'}}>
                                <ToggleSwitch label="Automated Collections Enabled" isOn={collectionsEnabled} handleToggle={handleCollectionsToggleAndSave} disabled={isSaving} />
                                <p style={{...styles.mutedText, marginLeft: '0px', marginTop: '4px'}}>MPLOI will automatically manage overdue invoices when enabled.</p>
                            </div>
                            
                            <div style={styles.formRow}>
                                <div style={styles.formCol}>
                                    <div style={styles.blueBox}>
                                        <h3 style={styles.sectionTitle}><span role="img" aria-label="robot">🤖</span> AI Configuration</h3>
                                        <label htmlFor="aiVoice" style={styles.label}>Default AI Voice (Outbound)</label>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <select id="aiVoice" style={{ ...styles.select, flexGrow: 1, marginBottom: '0px' }} value={selectedVoice} onChange={(e) => setSelectedVoice(e.target.value)} disabled={isSaving}>
                                                {AVAILABLE_VOICES.map(v => <option key={v.id} value={v.id} style={styles.selectOption}>{v.name}</option>)}
                                            </select>
                                            <button style={{ ...styles.button, ...styles.previewButton }} onClick={() => handleVoicePreview(selectedVoice)} disabled={isSaving || isPlayingPreview}>{isPlayingPreview ? '⏹️' : '▶️'}</button>
                                        </div>
                                        <div style={{marginTop: '12px'}}>
                                            <label htmlFor="aiPersonality" style={styles.label}>Default AI Personality (Outbound)</label>
                                            <select id="aiPersonality" style={styles.select} value={personality} onChange={(e) => setPersonality(e.target.value)} disabled={isSaving}>
                                                {PERSONALITY_TYPES.map(t => <option key={t.id} value={t.id} style={styles.selectOption}>{t.name} - {t.description}</option>)}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div style={styles.formCol}>
                                    <div style={styles.blueBox}>
                                        <h3 style={styles.sectionTitle}><span role="img" aria-label="megaphone">📣</span> Outbound Call Greetings</h3>
                                        <label htmlFor="outboundKnownGreeting" style={styles.label}>Known Customer</label>
                                        <textarea id="outboundKnownGreeting" style={{ ...styles.input, ...styles.textarea }} value={outboundKnownCustomerGreeting} onChange={(e) => setOutboundKnownCustomerGreeting(e.target.value)} disabled={isSaving} />
                                        <p style={{...styles.mutedText, marginTop: '-8px', marginBottom: '8px'}}>Vars: {'{customer_name}'}, {'{agent_name}'}, {'{organization_name}'}</p>
                                        
                                        <label htmlFor="outboundUnknownGreeting" style={styles.label}>Unknown Customer</label>
                                        <textarea id="outboundUnknownGreeting" style={{ ...styles.input, ...styles.textarea }} value={outboundUnknownCustomerGreeting} onChange={(e) => setOutboundUnknownCustomerGreeting(e.target.value)} disabled={isSaving} />
                                        <p style={{...styles.mutedText, marginTop: '-8px'}}>Vars: {'{agent_name}'}, {'{organization_name}'}</p>
                                    </div>
                                </div>
                            </div>

                            <div style={styles.blueBox}>
                                <h3 style={styles.sectionTitle}><span role="img" aria-label="phone receiver">📞</span> Incoming Call Settings</h3>
                                {/* <div style={{marginBottom: '16px'}}>
                                    <p style={styles.label}>Your MPLOI Incoming Phone Number:</p>
                                    <p style={{...styles.whiteText, fontSize: '16px', fontWeight: 'bold', background: 'rgba(0,0,0,0.2)', padding: '6px 10px', borderRadius: '4px', display: 'inline-block'}}>+61 437 485 000</p>
                                </div> */}
                                <div style={styles.formRow}>
                                    <div style={styles.formCol}>
                                        <label htmlFor="incomingKnownGreeting" style={styles.label}>Known Caller Message</label>
                                        <textarea id="incomingKnownGreeting" style={{ ...styles.input, ...styles.textarea }} value={incomingKnownCustomerGreeting} onChange={(e) => setIncomingKnownCustomerGreeting(e.target.value)} disabled={isSaving} />
                                        <p style={{...styles.mutedText, marginTop: '-8px'}}>Vars: {'{customer_name}'}, {'{organization_name}'}</p>
                                    </div>
                                    <div style={styles.formCol}>
                                        <label htmlFor="incomingUnknownMessage" style={styles.label}>Unknown Caller Message</label>
                                        <textarea id="incomingUnknownMessage" style={{ ...styles.input, ...styles.textarea }} value={incomingUnknownCustomerMessage} onChange={(e) => setIncomingUnknownCustomerMessage(e.target.value)} disabled={isSaving} />
                                        <p style={{...styles.mutedText, marginTop: '-8px'}}>Var: {'{organization_name}'}</p>
                                    </div>
                                </div>
                            </div>
                            
                            <div style={styles.blueBox}>
                                <h3 style={styles.sectionTitle}><span role="img" aria-label="strategy">🎯</span> Outbound Call Strategy</h3>
                                <div style={styles.formRow}>
                                    <div style={styles.formCol}>
                                        <label htmlFor="initialCallDays" style={styles.label}>Initial call if invoice is past payment terms by:</label>
                                        <select id="initialCallDays" style={styles.select} value={initialCallDaysPastPaymentTerms} onChange={(e) => setInitialCallDaysPastPaymentTerms(Number(e.target.value))} disabled={isSaving}>
                                            {[0, 1, 3, 5, 7, 14, 30].map(d => <option key={d} value={d}>{d === 0 ? "Immediately" : `${d} day${d === 1 ? '' : 's'}`}</option>)}
                                        </select>
                                    </div>
                                    <div style={styles.formCol}>
                                        <label htmlFor="maxAttempts" style={styles.label}>Max call attempts per invoice:</label>
                                        <input type="number" id="maxAttempts" style={styles.input} value={maxAttempts} onChange={(e) => setMaxAttempts(Number(e.target.value))} min={1} max={10} disabled={isSaving} />
                                    </div>
                                </div>
                                <div style={{borderTop: '1px solid rgba(255, 255, 255, 0.1)', paddingTop: '16px', marginTop: '16px'}}>
                                    <ToggleSwitch
                                        label="Limit calls based on invoice amount"
                                        isOn={limitCallsByAmountEnabled}
                                        handleToggle={() => setLimitCallsByAmountEnabled(!limitCallsByAmountEnabled)}
                                        disabled={isSaving}
                                    />
                                    {limitCallsByAmountEnabled && (
                                        <div style={{paddingLeft: '20px', marginTop: '8px'}}>
                                            <p style={{...styles.label, marginBottom: '8px'}}>Only call customers for invoices with an amount...</p>
                                            <div style={{display: 'flex', gap: '10px', alignItems: 'center'}}>
                                                <select
                                                    style={{...styles.select, width: 'auto', flexGrow: 1, marginBottom: 0}}
                                                    value={limitCallsComparisonType}
                                                    onChange={(e) => setLimitCallsComparisonType(e.target.value)}
                                                    disabled={isSaving}
                                                >
                                                    <option value="greater_than" style={styles.selectOption}>Greater than</option>
                                                    <option value="less_than" style={styles.selectOption}>Less than</option>
                                                </select>
                                                <span style={{...styles.whiteText, fontSize: '16px'}}>$</span>
                                                <input
                                                    type="number"
                                                    style={{...styles.input, width: '120px', marginBottom: 0}}
                                                    value={limitCallsAmount}
                                                    onChange={(e) => setLimitCallsAmount(Number(e.target.value))}
                                                    min={0}
                                                    disabled={isSaving}
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div style={{marginTop: '12px'}}>
                                    <ToggleSwitch label="Enable pre-due date reminder calls" isOn={enablePreDueDateReminders} handleToggle={() => setEnablePreDueDateReminders(!enablePreDueDateReminders)} disabled={isSaving} />
                                    {enablePreDueDateReminders && (
                                        <div style={{paddingLeft: '20px', marginTop: '8px'}}>
                                            <label htmlFor="reminderDays" style={styles.label}>Make reminder call when invoice is due in:</label>
                                            <select id="reminderDays" style={styles.select} value={reminderDaysBeforeDueDate} onChange={(e) => setReminderDaysBeforeDueDate(Number(e.target.value))} disabled={isSaving}>
                                                {PRE_DUE_DATE_REMINDER_OPTIONS.map(d => <option key={d} value={d}>{d} day{d === 1 ? '' : 's'}</option>)}
                                            </select>
                                        </div>
                                    )}
                                </div>
                                <h4 style={{...styles.label, marginTop: '20px', fontSize: '14px', fontWeight: '600'}}>Personality Overrides (based on days past payment terms):</h4>
                                {personalityOverrides.map((override, index) => (
                                    <div key={index} style={styles.overrideTier}>
                                        <ToggleSwitch label={`Enable Override Tier ${index + 1}`} isOn={override.enabled} handleToggle={() => handlePersonalityOverrideChange(index, 'enabled', !override.enabled)} disabled={isSaving} />
                                        {override.enabled && (
                                            <div style={styles.formRow}>
                                                <div style={styles.formCol}>
                                                    <label style={styles.label}>If invoice is &gt; X days past terms:</label>
                                                    <input type="number" style={styles.input} value={override.daysPastPaymentTerms} onChange={e => handlePersonalityOverrideChange(index, 'daysPastPaymentTerms', Number(e.target.value))} min={1} disabled={isSaving} />
                                                </div>
                                                <div style={styles.formCol}>
                                                    <label style={styles.label}>Change personality to:</label>
                                                    <select style={styles.select} value={override.personalityId} onChange={e => handlePersonalityOverrideChange(index, 'personalityId', e.target.value)} disabled={isSaving}>
                                                        {PERSONALITY_TYPES.map(p => <option key={p.id} value={p.id} style={styles.selectOption}>{p.name}</option>)}
                                                    </select>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>


                            <div style={styles.blueBox}>
                                <h3 style={styles.sectionTitle}><span role="img" aria-label="clock">⏰</span> Operating Hours</h3>
                                <p style={styles.infoText}>Define when MPLOI is active. Times are based on your organization's timezone.</p>
                                {timetable.map((daySchedule, dayIndex) => (
                                    <div key={daySchedule.day} style={styles.timetableDayRow}>
                                        <div style={styles.timetableDayLabel}>{daySchedule.day}</div>
                                        <div style={styles.timetableShiftsWrapper}>
                                            {daySchedule.shifts.map((shift, shiftIndex) => (
                                                <div key={shiftIndex} style={styles.timetableShiftContainer}>
                                                    <div style={styles.timetableShiftHeader}>
                                                        <span style={{...styles.whiteText, fontWeight: 500, fontSize: '13px'}}>Shift {shiftIndex + 1}</span>
                                                        <ToggleSwitch isOn={shift.enabled} handleToggle={() => handleTimetableChange(dayIndex, shiftIndex, 'enabled', !shift.enabled)} disabled={isSaving} label={shift.enabled ? "Active" : "Inactive"} />
                                                    </div>
                                                    {shift.enabled && (
                                                        <div style={styles.timetableShiftControls}>
                                                            <div><label style={{...styles.label, fontSize: '12px'}}>Start</label><input type="time" style={styles.timeInput} value={shift.startTime} onChange={e => handleTimetableChange(dayIndex, shiftIndex, 'startTime', e.target.value)} disabled={isSaving} /></div>
                                                            <div><label style={{...styles.label, fontSize: '12px'}}>End</label><input type="time" style={styles.timeInput} value={shift.endTime} onChange={e => handleTimetableChange(dayIndex, shiftIndex, 'endTime', e.target.value)} disabled={isSaving} /></div>
                                                            <div><label style={{...styles.label, fontSize: '12px'}}>Voice</label><select style={{...styles.select, marginBottom: 0, padding: '6px 8px'}} value={shift.voiceId} onChange={e => handleTimetableChange(dayIndex, shiftIndex, 'voiceId', e.target.value)} disabled={isSaving}>{AVAILABLE_VOICES.map(v => <option key={v.id} value={v.id} style={styles.selectOption}>{v.name}</option>)}</select></div>
                                                            <div><label style={{...styles.label, fontSize: '12px'}}>Personality</label><select style={{...styles.select, marginBottom: 0, padding: '6px 8px'}} value={shift.personalityId} onChange={e => handleTimetableChange(dayIndex, shiftIndex, 'personalityId', e.target.value)} disabled={isSaving}>{PERSONALITY_TYPES.map(p => <option key={p.id} value={p.id} style={styles.selectOption}>{p.name}</option>)}</select></div>
                                                        </div>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div style={styles.blueBox}>
                                <h3 style={styles.sectionTitle}><span role="img" aria-label="shield">🛡️</span> Privacy & Recordings</h3>
                                <ToggleSwitch label="Store Call Recordings" isOn={storeCallRecordings} handleToggle={() => setStoreCallRecordings(!storeCallRecordings)} disabled={isSaving} />
                                {storeCallRecordings && (
                                    <div style={{ marginTop: '12px' }}>
                                        <label htmlFor="recordingAnnouncement" style={styles.label}>Recording Announcement Message</label>
                                        <textarea id="recordingAnnouncement" style={{ ...styles.input, ...styles.textarea }} value={recordingAnnouncement} onChange={(e) => setRecordingAnnouncement(e.target.value)} disabled={isSaving} />
                                        <p style={{...styles.mutedText, marginTop: '-8px'}}>Played at the start of recorded calls. Ensure compliance.</p>
                                    </div>
                                )}
                            </div>

                            <div style={styles.saveButtonContainer}>
                                <button style={{ ...styles.button, ...styles.primaryButton, padding: '10px 24px', fontSize: '14px' }} onClick={handleSaveSettings} disabled={isSaving || isLoading}>
                                    {isSaving ? 'Saving...' : 'Save All Settings'}
                                </button>
                            </div>
                        </div> 
                    </div> 
                </div> 
            </div> 
            {isSaving && <div style={styles.loadingOverlay}><div className="spinner-border" style={{ width: '3rem', height: '3rem', color: '#007bff' }} role="status"><span className="sr-only">Saving...</span></div></div>}
        </section>
    );
};

export default WhitelabelSettings;